import { DatePipe,Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgOtpInputComponent, NgOtpInputConfig } from 'ng-otp-input';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { ExitingpatientService } from 'src/app/services/exitingpatient.service';
import { RegistorpatientService } from 'src/app/services/registorpatient.service';
import { VerifypatientService } from 'src/app/services/verifypatient.service';
import { PatientPersonalInfo,VerifypatientModule,getPatientDataByURl } from 'src/app/models/verifypatient/verifypatient';
import { UpdateinfoService } from '../../services/updateinfo.service';
import moment from 'moment';
import { PaymentService } from 'src/app/services/payment.service';
import { PaymentDeiails } from '../../models/registeration/payment_models';

declare var $: any;
@Component({
  selector: 'app-exitingpatientlogin',
  templateUrl: './exitingpatientlogin.component.html',
  styleUrls: ['./exitingpatientlogin.component.css']
})
export class ExitingpatientloginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup = new FormGroup({});
  first_name: any;
  last_Name: any;
  Dob: any;
  maxDate:any;
  practice_phone:any;
  practice_name:any;
  patientpersonalinfo :any;
  curDate = new Date();
  flowType = '';
  selectedDay: any;
  selectedMonth: any;
  selectedYear: any;
  months: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  years: number[] = [];
  encryptedPracticeCode: any
  getPatientInfo: getPatientDataByURl = new getPatientDataByURl();
  VerifypatientModule: VerifypatientModule;
  PatientPersonalInfo: PatientPersonalInfo;
  selectedLanguage: any = 'en';
  isLockScreen: boolean = false;
  showDOBForCheckin: boolean = true;
  daysInMonth: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];

  constructor(private translateService: TranslateService, private spinner: NgxSpinnerService, private _phrutilService: PhrutillsService, private _login: ExitingpatientService, private datepipe: DatePipe,
    private _router: Router, private _route: ActivatedRoute, private _registor: RegistorpatientService, private location: Location, private _VerifypatientService: VerifypatientService, private updateinfoservice: UpdateinfoService,private service: PaymentService, private phrUtils: PhrutillsService,) {
      let info = localStorage.getItem('PatientInfo');
      if(!info){
        this._router.navigateByUrl("/home?practice_code=''");
        return;
      }
      this.reset();
      this.maxDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this._route.queryParams.subscribe((param) => {
        if (param.type) {
          this.flowType = param.type;
          if (this.flowType =='appointment') {
            this._phrutilService.patientlanguage$.subscribe(language => {
              console.log("dafault " + language);
              if (language === 'es') {
                this._phrutilService.setTitle('Reserve una cita');
              } else if (language === 'hi') {
                this._phrutilService.setTitle('अपॉइंटमेंट बुक करें');
              } else if (language === 'ur') {
                this._phrutilService.setTitle('اپوائنٹمنٹ بک کریں');
              }
              else {
                this._phrutilService.setTitle('Book an Appointment');
              }
            });
          } else {
            this._phrutilService.patientlanguage$.subscribe(language => {
              console.log("dafault " + language);
              if (language === 'es') {
                this._phrutilService.setTitle('Pagar el saldo adeudado');
              } else if (language === 'hi') {
                this._phrutilService.setTitle('बकाया राशि का भुगतान करें');
              } else if (language === 'ur') {
                this.phrUtils.setTitle('بقایا بیلنس ادا کریں');
              }
              else {
                this._phrutilService.setTitle('Pay Due Balance');
              }
            });
          }
        } else {
          // this.isNameFieldsEnabledForCheckin = false;
          // this.removeNameValidation();
          // console.log("name field", this.isNameFieldsEnabledForCheckin);
          this._phrutilService.patientlanguage$.subscribe(language => {
            console.log("dafault " + language);
            if (language === 'es') {
              this._phrutilService.setTitle('Regístrese para una cita');
            } else if (language === 'hi') {
              this._phrutilService.setTitle('अपॉइंटमेंट के लिए चेक-इन करें');
            } else if (language === 'ur') {
              this._phrutilService.setTitle('اپوائنٹمنٹ کے لیے چیک ان کریں');
            }
            else {
              this._phrutilService.setTitle('Check-in for Appointment');
            }
          });
        }
      });
      
    }
    
    buildregistrationForm() {
      this.loginForm = new FormGroup({
        firstname: new FormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]),
        lastname: new FormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]),
        //dob: new FormControl('', Validators.required),
        dobDay: new FormControl('', [Validators.required]),
        dobMonth: new FormControl('', [Validators.required]),
        dobyear: new FormControl('', [Validators.required])
        
      });
      
  }
    
  ObjAction: any = {};
  trackPatientPreference(lf: any) {
    console.log("landed from ", lf);
    this.ObjAction['patientAccount'] = this.getPatientInfo.patientAccount;
    this.ObjAction['practiceCode'] = this.getPatientInfo.practiceCode;
    this.ObjAction['appointmentID'] = this.getPatientInfo.appointment_id;
    this.ObjAction['action'] = lf;
    this.ObjAction['createdBy'] = this.getPatientInfo.firstName + " " + this.getPatientInfo.lastName;
    this.ObjAction['appSource'] = "breezeCheckin";
    console.log("action object ", this.ObjAction);
    this._VerifypatientService.ManageActionItems(this.ObjAction).subscribe((res: any) => {
      console.log(res);
    }, (error: any) => {
      console.log(error);
    })
  }

    get getloginForm() {
      return this.loginForm.controls;
  }

  enableNameValidation() {
    //this.isNameFieldsEnabledForCheckin = true; 
    this.loginForm.controls['firstname'].setValidators([Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]);
    this.loginForm.controls['lastname'].setValidators([Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]);

   // this.loginForm.controls['firstname'].updateValueAndValidity();
  //  this.loginForm.controls['lastname'].updateValueAndValidity();
  }

  removeNameValidation() {
    this.loginForm.controls['firstname'].clearValidators();
    this.loginForm.controls['lastname'].clearValidators();
  }
    
    reset() {
      this.loginForm.reset();
      this.buildregistrationForm();
  }

  IslandeFromQRCode: boolean = false;

  ngOnInit(): void {
    const landfrom = localStorage.getItem("landFrom");
    if (landfrom != undefined && landfrom != null && landfrom == 'qrcode') {
      this.IslandeFromQRCode = true;
      this._phrutilService.setTitle('Verify Patient');
    }
    this.populateYears();
    this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
    // console.log(this.patientpersonalinfo);
    this._phrutilService.setNavpracName(this.patientpersonalinfo.prac_Name);
      if(this.patientpersonalinfo.practicePhone){
        this.phoneLink =  "tel:+1"+this.patientpersonalinfo.practicePhone;
        this.practice_phone = this._phrutilService.maskingPhoneNumer(this.patientpersonalinfo.practicePhone);
      }
    }
  populateYears(): void {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 100;
    const endYear = currentYear;

    for (let i = endYear; i >= startYear; i--) {
      this.years.push(i);
    }
  }
  ValidatePersonalInfo(data: any, type: any) {
      
      let validname = data.target.value.replace(/[^a-zA-Z ]/g, "");
      data.target.value = validname;
      if (type == 'firstname') {
        if (validname != '') {
          this.first_name = validname;
        } else {
          this.first_name = validname;
        }
      } else if (type == 'lastname') {
        if (validname != '') {
          this.last_Name = validname;
        }
        else {
          this.last_Name = validname;
        }
      }
    }
  updateDays(event: any) {

    const selectedDay = this.loginForm.controls['dobDay'].value;
    console.log(selectedDay);
    this.selectedMonth = parseInt(this.loginForm.controls['dobMonth'].value, 10);
    this.selectedYear = parseInt(this.loginForm.controls['dobyear'].value, 10) || new Date().getFullYear();

    if (this.selectedMonth) {
      console.log("inside update days");
      const daysInSelectedMonth = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
      console.log(daysInSelectedMonth);
      this.daysInMonth = Array.from({ length: daysInSelectedMonth }, (_, i) => i + 1);
      if (selectedDay != '') {
        if (selectedDay > daysInSelectedMonth) {
          this.loginForm.controls['dobDay'].setValue('');
        } else {
          this.loginForm.controls['dobDay'].setValue(selectedDay);
        }
      }

    } else {
      this.daysInMonth = Array.from({ length: 31 }, (_, i) => i + 1);
    }
  }
  loginResp: any = null;
  date_of_birth: any

  showModal: boolean = false;
  isMinuDueAmount: string = "false";
  isMinuTotalAmount: string = "false";
  paymentDetials: PaymentDeiails = new PaymentDeiails();
  amountDueTemp: Number;
  isCopay: any = false;
  isoutstanding: any = false;
  ShowAmountField: boolean = true;

  LoginPatient() {
    if (this.loginForm.valid) {
      const dobDay = this.loginForm.controls['dobDay'].value;

      const dobMonth = this.loginForm.controls['dobMonth'].value;

      const dobYear = this.loginForm.controls['dobyear'].value;

     // const paddedDobDay = dobDay.toString().padStart(2, '0');
     // const paddedDobMonth = dobMonth.toString().padStart(2, '0');
     // var dateOfBirth = dobYear + "-" + paddedDobMonth + "-" + paddedDobDay;
     // var dobDate = new Date(dateOfBirth);
      this.date_of_birth = dobMonth + "/" + dobDay + "/" + dobYear;
    //  this.date_of_birth = this.datepipe.transform(dobDate, 'MM/dd/yyyy');
      this.loginForm.markAllAsTouched();
      if (!this.loginForm.invalid) {
        //if((new Date(this.maxDate)) < (new Date(this.loginForm.get('dob')!.value)))
        //{
        //  let text = "Future date of birth is not allowed.";
        //  this.translateService.get('Alerts.future_dob_not_allowed').subscribe((translation: string) => {
        //    text = translation;
        //  });
        //  this._phrutilService.showInfo(text);
        //  //this._phrutilService.showInfo('Future date of birth is not allowed.');
        //  return;
        //}
        this.spinner.show();
        //const encryptedPracticeCode = this._phrutilService.encrypt(this.patientpersonalinfo.practice_code);
        //const encryptedPracticeCode = encodeURIComponent(this._phrutilService.encrypt(this.patientpersonalinfo.practice_code));



        this._login.VerifyExistingPatientByNameDob(this.first_name, this.last_Name, this.date_of_birth, this.patientpersonalinfo.practice_code).subscribe((res: any) => {
            this.spinner.hide();
            if (res.statusCode == 200 && res.data.status.toLowerCase() == 'success') {
              this.loginResp = res.data;
              //this.SendOTP();

              this.patientpersonalinfo.date_Of_Birth = this.loginResp.date_Of_Birth;
              this.patientpersonalinfo.email_Address = this.loginResp.email_Address;
              this.patientpersonalinfo.cell_phone = this.loginResp.cell_phone;
              this.patientpersonalinfo.first_Name = this.loginResp.first_Name;
              this.patientpersonalinfo.last_Name = this.loginResp.last_Name;
              this.patientpersonalinfo.practice_Code = this.loginResp.practice_Code;
              this.patientpersonalinfo.prac_Name = this.loginResp.prac_Name;
              this.patientpersonalinfo.patient_Account = this.loginResp.patient_Account;
              this.patientpersonalinfo.prac_Phone = this.loginResp.prac_Phone;
              this.patientpersonalinfo.gender = this.loginResp.gender;
              let data = this._phrutilService.encrypt(this.patientpersonalinfo);
              localStorage.setItem("AuthTokenwebServices", this.loginResp.accessTokenResponse.accessToken);
              localStorage.setItem("RefreashTokenwebServices", this.loginResp.accessTokenResponse.refreshToken);
              localStorage.setItem('PatientInfo', data);
              if (this.patientpersonalinfo.type == 'walkin') {
                this._router.navigateByUrl("/exitingappointment")
              }
              else if (this.patientpersonalinfo.type == 'check-in') {
                this.getCheckinDetails(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account);
              }

              else if (this.patientpersonalinfo.type == 'payment') {
                this.getPaymentDetails();
              }

            }
            else if (res.data.status.toLowerCase() == 'no record found') {
              $("#isNotValid_linkexiting").modal("show");
              return;
            }
            else if (res.data.status.toLowerCase() == 'more then one patient exit with these info') {
              $("#ismorethenonepatient").modal("show");
              return;
            }
          }, (error: any) => {
            $("#isNotValid_linkexiting").modal("show");
            this.spinner.hide();
            return;
          });
      }
      else {
        return;
      }
    } else {
      this.loginForm.markAllAsTouched();
    }
   
    }

  phoneLink: any;
  patientLanguage: any;
  increment: any = 0;
  isWithin24Hours: any;
  isWithin3Hours: any;
  //isNameFieldsEnabledForCheckin: boolean = true;

  getPatientData(pracCode: any,first_name:any,last_name:any, dob: any) {

    this.spinner.show();
    this._VerifypatientService.VerifyExistingPatientByDob(pracCode, first_name, last_name, dob).subscribe((res: any) => {
      this.spinner.hide();
      //console.log("response ", res);
      if (res.data) {
        /*if (res.data.status !== 'no appointment found') {*/
        if (res.data.status == 'success') {

          //store the access and refreash token in the localStorage
          localStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
          sessionStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
          localStorage.setItem("RefreashTokenwebServices", res.data.accessTokenResponse.refreshToken);
          localStorage.setItem('pictureAddress', res.data.picture_Address);
          console.log("verii " + res.data.accessTokenResponse.accessToken);
          console.log("verii loc GetData" + localStorage.getItem("AuthTokenwebServices"));
          //console.log(res.data);
          this.getPatientInfo.emailAddress = res.data.emailAddress ? this._phrutilService.decryptforServices(res.data.emailAddress) : res.data.emailAddress;
          this.getPatientInfo.visitDate = res.data.visitDate;
          localStorage.setItem('visitDate', this.getPatientInfo.visitDate);
          this.getPatientInfo.timE_FROM = res.data.timE_FROM;
          this.getPatientInfo.visitReason = res.data.visitReason;
          this.getPatientInfo.dateOfBirth = res.data.dateOfBirth ? this._phrutilService.decryptforServices(res.data.dateOfBirth) : res.data.dateOfBirth;
          this.getPatientInfo.cellPhone = res.data.cellPhone ? this._phrutilService.decryptforServices(res.data.cellPhone) : res.data.cellPhone;
          this.getPatientInfo.firstName = res.data.firstName ? this._phrutilService.decryptforServices(res.data.firstName) : res.data.firstName;
          this.getPatientInfo.lastName = res.data.lastName ? this._phrutilService.decryptforServices(res.data.lastName) : res.data.lastName;
          this.getPatientInfo.practiceCode = res.data.practiceCode ? this._phrutilService.decryptforServices(res.data.practiceCode) : res.data.practiceCode;
          this.getPatientInfo.todaY_AMMOUNT = res.data.todaY_AMMOUNT;
          this.getPatientInfo.previouS_AMMOUNT = res.data.previouS_AMMOUNT;
          this.getPatientInfo.providerLastName = res.data.providerLastName ? this._phrutilService.decryptforServices(res.data.providerLastName) : res.data.providerLastName;
          this.getPatientInfo.providerFirstName = res.data.providerFirstName ? this._phrutilService.decryptforServices(res.data.providerFirstName) : res.data.providerFirstName;
          this.getPatientInfo.providerCode = res.data.providerCode ? this._phrutilService.decryptforServices(res.data.providerCode) : res.data.providerCode;
          this.getPatientInfo.practiceName = res.data.practiceName ? this._phrutilService.decryptforServices(res.data.practiceName) : res.data.practiceName;
          this.getPatientInfo.patientAccount = res.data.patientAccount ? this._phrutilService.decryptforServices(res.data.patientAccount) : res.data.patientAccount;
          this.getPatientInfo.appointment_id = res.data.appointment_id ? this._phrutilService.decryptforServices(res.data.appointment_id) : res.data.appointment_id;
          this.getPatientInfo.practicePhone = res.data.practicePhone ? this._phrutilService.decryptforServices(res.data.practicePhone) : res.data.practicePhone;
          this.getPatientInfo.picture_Address = res.data.picture_Address ? this._phrutilService.decryptforServices(res.data.picture_Address) : res.data.picture_Address;
          this.getPatientInfo.languages = res.data.languages ? this._phrutilService.decryptforServices(res.data.languages) : res.data.languages;
          this.getPatientInfo.practiceAddress = res.data.practiceAddress ? this._phrutilService.decryptforServices(res.data.practiceAddress) : res.data.practiceAddress;
          this.getPatientInfo.PracticeCity = res.data.practiceCity ? this._phrutilService.decryptforServices(res.data.practiceCity) : res.data.practiceCity;
          this.getPatientInfo.practiceState = res.data.practiceState ? this._phrutilService.decryptforServices(res.data.practiceState) : res.data.practiceState;
          this.getPatientInfo.praticeZip = res.data.praticeZip ? this._phrutilService.decryptforServices(res.data.praticeZip) : res.data.praticeZip;
          this.getPatientInfo.praticeZip = this._phrutilService.maskingZipNum(this.getPatientInfo.praticeZip);
          this.getPatientInfo.reason_Id = res.data.reason_Id ? this._phrutilService.decryptforServices(res.data.reason_Id) : res.data.reason_Id;
          this.getPatientInfo.reasonName = res.data.reasonName ? this._phrutilService.decryptforServices(res.data.reasonName) : res.data.reasonName;
          this.getPatientInfo.appointmentStatusId = res.data.appointmentStatusId ? this._phrutilService.decryptforServices(res.data.appointmentStatusId) : res.data.appointmentStatusId;
          this.getPatientInfo.appointment_End_DateTime = res.data.appointment_End_DateTime ? this._phrutilService.decryptforServices(res.data.appointment_End_DateTime) : res.data.appointment_End_DateTime;
          this.getPatientInfo.appointmentDuration = res.data.appointmentDuration ? this._phrutilService.decryptforServices(res.data.appointmentDuration) : res.data.appointmentDuration;
          this.getPatientInfo.appointmentAddress = res.data.appointmentAddress ? this._phrutilService.decryptforServices(res.data.appointmentAddress) : res.data.appointmentAddress;
          this.getPatientInfo.appointmentState = res.data.appointmentState ? this._phrutilService.decryptforServices(res.data.appointmentState) : res.data.appointmentState;
          this.getPatientInfo.appointmentCity = res.data.appointmentCity ? this._phrutilService.decryptforServices(res.data.appointmentCity) : res.data.appointmentCity;
          this.getPatientInfo.appointmentZip = res.data.appointmentZip ? this._phrutilService.decryptforServices(res.data.appointmentZip) : res.data.appointmentZip;
          this.getPatientInfo.appointmentZip = this._phrutilService.maskingZipNum(this.getPatientInfo.appointmentZip);
        
          this.getPatientInfo.isBreezePaymentEnabled = res.data.isBreezePaymentEnabled;
          this.getPatientInfo.isPayLaterEnabled = res.data.isPayLaterEnabled;
          let data = this._phrutilService.encrypt(this.getPatientInfo);
          localStorage.setItem('PatientInfoCheckin', data);
          const landfrom = localStorage.getItem("landFrom");
          if (landfrom != undefined && landfrom != null) {
            this.trackPatientPreference(landfrom);
          }
          //this.trackPatientPreference("QR code scan");
          //console.log("patient details ",this.getPatientInfo);
          console.log("ispaylater enabled ", this.getPatientInfo.isPayLaterEnabled);
          console.log("appt status id ", this.getPatientInfo.appointmentStatusId);
          console.log("appt start time ", this.getPatientInfo.timE_FROM);
          console.log("appt end time ", this.getPatientInfo.appointment_End_DateTime);
          console.log("isBreezePaymentEnabled ", this.getPatientInfo.isBreezePaymentEnabled);
  
          localStorage.setItem("apptEndTime", this.getPatientInfo.appointment_End_DateTime);
          localStorage.setItem("apptStartTime", this.getPatientInfo.visitDate);
          localStorage.setItem("pcode", this.getPatientInfo.practiceCode);
          localStorage.setItem("reason", this.getPatientInfo.reasonName);
          localStorage.setItem("state", this.getPatientInfo.practiceState);
          localStorage.setItem("city", this.getPatientInfo.PracticeCity);
          localStorage.setItem("zip", this.getPatientInfo.praticeZip);
          localStorage.setItem("Pcell", this.getPatientInfo.practicePhone);
          localStorage.setItem("Padder", this.getPatientInfo.practiceAddress);
          localStorage.setItem("prcode", this.getPatientInfo.providerCode);
          localStorage.setItem("apptId", this.getPatientInfo.appointment_id);
          localStorage.setItem("apptstId", this.getPatientInfo.appointmentStatusId);
          localStorage.setItem("ptcode", this.getPatientInfo.patientAccount);
          localStorage.setItem("fname", this.getPatientInfo.firstName);
          localStorage.setItem("lname", this.getPatientInfo.lastName);
          localStorage.setItem("isBreezePaymentEnabled", this.getPatientInfo.isBreezePaymentEnabled);
          localStorage.setItem("isPayLaterEnabled", this.getPatientInfo.isPayLaterEnabled);


          this.isWithin3Hours = this.checkinBeforeThreeHours(this.getPatientInfo.visitDate, this.getPatientInfo.timE_FROM);
          localStorage.setItem('isWithin3Hours', this.isWithin3Hours);
          console.log("is with in 3 hours " + this.isWithin3Hours)
          if ((this.getPatientInfo.practiceCode == '1011163' || this.getPatientInfo.practiceCode == '100') && this.getPatientInfo.reasonName == 'Initial Visit') {
            // console.log("using zahid function " + this.ConverttoLocalDate(this.getPatientInfo.visitDate));
            this.isWithin24Hours = this.checkIfVisitWithin24Hours(this.getPatientInfo.visitDate, this.getPatientInfo.timE_FROM);
            console.log("is Same date " + this.isWithin24Hours); // Output: true or false
            localStorage.setItem('isWithin24Hours', this.isWithin24Hours);
          }

          this._phrutilService.setNavbarLastName(this.getPatientInfo.lastName);
          this._phrutilService.setNavpracName(this.getPatientInfo.practiceName);
         /* console.log(this.getPatientInfo.languages + "language");
          if (this.getPatientInfo.languages == 'Spanish') {
            this.patientLanguage = 'es';
            localStorage.setItem('language', this.patientLanguage);
            this.selectedLanguage = this.patientLanguage;
            this.translateService.use(this.selectedLanguage)
            this._phrutilService.setdeafultLanguage(this.selectedLanguage);
            this._phrutilService.setPatientLanguage(this.selectedLanguage);
            console.log(this.selectedLanguage);
          } else {
            this.patientLanguage = 'en';
            localStorage.setItem('language', this.patientLanguage);
            this.selectedLanguage = this.patientLanguage;
            this.translateService.use(this.selectedLanguage)
            this._phrutilService.setdeafultLanguage(this.selectedLanguage);
            this._phrutilService.setPatientLanguage(this.selectedLanguage);
           // $("#language-modal").modal("show");
          }*/

          if (this.getPatientInfo.practicePhone) {
            this.phoneLink = "tel:+1" + this.getPatientInfo.practicePhone;
            this.getPatientInfo.practicePhone = this._phrutilService.maskingPhoneNumer(this.getPatientInfo.practicePhone);
          }
          /*
          // Log Rocket Implementation
          const LogRocket = require('logrocket/setup')({
            sdkServer: 'https://logrocket.carecloud.com',
            ingestServer: 'https://logrocket.carecloud.com'
          });
          LogRocket.init('carecloud/breeze-checkin');
          LogRocket.startNewSession();
          LogRocket.identify(this.getPatientInfo.patientAccount, {
            name: this.getPatientInfo.patientAccount,
            email: this.getPatientInfo.emailAddress,
            // Add your own custom user variables here, ie:
            subscriptionType: 'pro'
          });*/
          this._router.navigateByUrl("/appoin-mes");
        }
        else {
          $("#isNotValid_linkexiting").modal("show");
          return;
        }

      }
      /*
      no appointment found
      more than one patient has an appointment today
      more than one patient exists
      more than one first name exists.
      more than one last name exists.
      more than one patient with same first name and last name exists.
      more than one patient exists with same dob
      */
      else if (res.message.toLowerCase() == 'no record found') {
        $("#isNotValid_linkexiting").modal("show");
        return;
      }
        //more than one first name exists.
        //more than one patient exists with same last name.
      else if (res.message.toLowerCase() == 'more than one patient exists with same dob.' || res.message.toLowerCase() == 'more than one first name exists.' || res.message.toLowerCase() == 'more than one patient exists with same last name.') {
      //  $("#ismorethenonepatient").modal("show");
       //this.isNameFieldsEnabledForCheckin = true;
        // this.showDOBForCheckin = false;
        // this.enableNameValidation();
        return;
      }
      else {
        $("#linkexpire-model").modal("show");
        return;
      }
    }, (error: any) => {
      this.spinner.hide();
      $("#linkexpire-model").modal("show");
      return;
    });
  }

  onSubmit() {
    if (this.loginForm.valid) {
      const dobDay = this.loginForm.controls['dobDay'].value;
      const dobMonth = this.loginForm.controls['dobMonth'].value;

      const dobYear = this.loginForm.controls['dobyear'].value;
      const formattedDate = dobMonth + "/" + dobDay + "/" + dobYear;
      console.log("formated date ", formattedDate);
     const firstname= this.loginForm.controls['firstname'].value;
      const lastname= this.loginForm.controls['lastname'].value;
      //const result = localStorage.getItem('pcode')
      //const encryptedPracticeCode = this._phrutilService.encrypt(result);
      console.log("new API hit");
     // this.getPatientData("DKaCtphNcNUv0Zud0xh3hA==", firstname, lastname, formattedDate);
      this.getPatientData(this.patientpersonalinfo.practice_Code, firstname, lastname, formattedDate);
    } else {
      this.loginForm.markAllAsTouched();
    }

  }

    @ViewChild(NgOtpInputComponent, { static: false })
    ngOtpInput: NgOtpInputComponent;
    @ViewChild('ngOtpInput') ngOtpInputRef: any;
    config: NgOtpInputConfig = {
      allowNumbersOnly: true,
      length: 4,
      isPasswordInput: false,
      disableAutoFocus: true,
      placeholder: '',
      letterCase: 'Upper',

    };
    //phoneLink: string;
    linkType: string;
    otpResp: any = null;
    isSendingOTP: boolean = false;
    SendOTP() {
      if(!this.loginResp){
        return;
      }
      this.phoneLink = '';
      this.linkType = '';
      let obj = {
        "applicationName": "BreezeCheckin",
        "userName": this.loginResp.cell_phone || this.loginResp.email_Address,
        "deviceInfo": "web",
        "appDisplayName": "Breeze Checkin"
      };
      
      this.phoneLink = this.loginResp.cell_phone || this.loginResp.email_Address;
      if(this.loginResp.cell_phone){
        this.linkType = 'phone number';
        this.phoneLink = '*** *** **' + this.phoneLink.substring(this.phoneLink.length-4, this.phoneLink.length);
      }
      else{
        let emailClient = this.phoneLink.split('@');
        this.linkType = 'email';
        this.phoneLink = this.phoneLink.substring(0, 1)+'*****@'+ emailClient[1];
      }
      
      this.spinner.show();
      this.isSendingOTP = true;
      this._login.SendOTP(obj).subscribe((res: any) => {
        this.isSendingOTP = false;
        this.remainingTime = 1;
        this.spinner.hide();
        $('#verifycode').modal('show');
        $('.ng-otp-input-wrapper').removeClass('wrapper');
        this.otpResp = res;
        if(res.status == true && res.message == 'OTP Sent'){
          this.OTPTimer(179);
          this.ngOtpInput.setValue('');
        }
        else {
          this._phrutilService.showError(res.message);
        }
      }, (error: any) => {
        this.isSendingOTP = false;
        this._phrutilService.showError(error.toString());
        this.spinner.hide();
      });
    }
    
    verResp: any = null;
    otpEntered: boolean = true;
    verifyOTP() {
      if(this.otpResp == null){
        return;
      }
      if (Number(this.s) == 0 && Number(this.m) == 0) {
        let text = "Code expired. Tap resend code and try again.";
        this.translateService.get('Alerts.code_expired').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
       // this._phrutilService.showError("Code expired. Tap resend code and try again.");
        return;
      }
      
      if (this.otp && this.otp.length == 4) {
        this.otpEntered = true;
        let obj = {
          "deviceInfo": "web",
          "notifier": this.otpResp.data,
          "otp": this.otp
        };
        this.spinner.show();
        this.isVerifying = true;
        this._login.VerifyOTP(obj).subscribe((res: any) => {
          this.isVerifying = false;
          this.spinner.hide();
          this.verResp = res;
          if (res.status == true && res.message.toLowerCase() == "otp verified successfully") { 
            $('#verifycode').modal('hide');
            this.patientpersonalinfo.date_Of_Birth = this.loginResp.date_Of_Birth;
            this.patientpersonalinfo.email_Address = this.loginResp.email_Address;
            this.patientpersonalinfo.cell_phone= this.loginResp.cell_phone;
            this.patientpersonalinfo.first_Name= this.loginResp.first_Name;
            this.patientpersonalinfo.last_Name= this.loginResp.last_Name;
            this.patientpersonalinfo.practice_Code= this.loginResp.practice_Code;
            this.patientpersonalinfo.prac_Name= this.loginResp.prac_Name;
            this.patientpersonalinfo.patient_Account= this.loginResp.patient_Account;
            this.patientpersonalinfo.prac_Phone= this.loginResp.prac_Phone;
            this.patientpersonalinfo.gender = this.loginResp.gender;
            let data = this._phrutilService.encrypt(this.patientpersonalinfo);
            localStorage.setItem("AuthTokenwebServices",this.loginResp.accessTokenResponse.accessToken); 
            localStorage.setItem("RefreashTokenwebServices",this.loginResp.accessTokenResponse.refreshToken); 
            localStorage.setItem('PatientInfo', data);
            if(this.patientpersonalinfo.type=='walkin')
            {
              this._router.navigateByUrl("/exitingappointment");
            }
            else if(this.patientpersonalinfo.type=='check-in')
            {
              this.getCheckinDetails(this.patientpersonalinfo.practice_Code,this.patientpersonalinfo.patient_Account);
            }
            else if(this.patientpersonalinfo.type=='payment')
            {
              this._router.navigateByUrl("/payment-overview");
            }
          }
          else if (res.message.toLowerCase().includes('failed')) {
            let text = "Invalid OTP Code. Try again.";
            this.translateService.get('Alerts.invalid_otp_code').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showError(text);
            //this._phrutilService.showError("Invalid OTP Code. Try again.");
          }
        }, (error: any) => {
          this.isVerifying = false;
          this._phrutilService.showError(error.toString());
          this.spinner.hide();
        });
      }
      else{
        this.otpEntered = false;
      }
    }
    
    otp: string = '';
    isVerifying : boolean = false;
    onOtpChange(otp: any) {
      if(this.isVerifying){
        return;
      }
      if(otp.length == 4){
        this.otp = otp;
        this.verifyOTP();
      }
      else {
        this.otp == '';
        this.isVerifying = false;
      }
    }
    
  //otp timer starts
  m: string = '00';
  s: string = '00';
  timer: any;
  remainingTime : number = 1;
  OTPTimer(remaining: any) {
    this.m = Math.floor(remaining/60).toString();
    this.s = (remaining % 60).toString();
    this.m = Number(this.m) < 10 ? '0' + this.m : this.m;
    this.s = Number(this.s) < 10 ? '0' + this.s : this.s;

    this.timer = setTimeout(() => {
      if (remaining >= 1) {
        this.remainingTime = remaining -= 1;
        this.OTPTimer(remaining);
        if(this.remainingTime == 0){
          this.timer = 0;
          this.clearTimer();
        }
      }
      else {
        return;
      }
    }, 1000);
  }
    
    getCheckinDetails(practice_code:any,patient_account:any)
    {
      this.spinner.show();
      this._login.GetCheckinDetails(practice_code,patient_account).subscribe((res:any)=>{
        this.spinner.hide();
        if(res.statusCode == 200 && res.data.status.toLowerCase()=='success')
        {
          this.patientpersonalinfo.appointmentid = res.data.appointment_Id;
          this.patientpersonalinfo.reason_Id = res.data.reason_Id;
          this.patientpersonalinfo.reasonName= res.data.reasonName;
          this.patientpersonalinfo.appointment_Date_Time= res.data.appointment_Date_Time;
          this.patientpersonalinfo.location_Id= res.data.location_Id;
          this.patientpersonalinfo.time_form= res.data.time_From;
          this.patientpersonalinfo.provider_Code= res.data.provider_Code;
          this.patientpersonalinfo.teleMedicine_Session= res.data.teleMedicine_Session;
          let data = this._phrutilService.encrypt(this.patientpersonalinfo);
          localStorage.setItem('PatientInfo', data);
          this._router.navigateByUrl("/appoin-mes");
        }
        else if(res.data.status.toLowerCase()=='no appointment for today')
        {
          $("#noAppointmentFound").modal("show");
        }
        else if(res.data.status.toLowerCase()=='already checked in')
        {
          $("#alreadycheckin").modal("show");
        }
        else
        {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
      },(error:any)=>{
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      });
    }
  //  backPage()
  //  {
  //    this.location.back();
  //    // this._router.navigateByUrl("/home?practice_code="+this.patientpersonalinfo.practice_Code);
  //}
  backPage() {
    this._route.queryParams.subscribe(params => {
      if (params['type'] === 'payment') {
        this._router.navigateByUrl("/home?practice_code=" + this.patientpersonalinfo.practice_code);
      } else {
        this.location.back();
      }
    });
  }

    focusOutFunction(e: any, type: any){
     // let date =  this.getloginForm.dob.value.split('-');
      // if(Number(date[0]) > this.curDate.getFullYear()){
        if((new Date(this.maxDate)) < (new Date(this.loginForm.get('dob')!.value)))
        {
        this.getloginForm.dob.setErrors({'maxDate': true, 'invalid': true});
      }
    }

    clearTimer(){
      clearTimeout(this.timer);
      this.timer = 0;
    }
    
    ngOnDestroy(): void {
      clearTimeout(this.timer);
      this.timer = 0;
  }
  verifyPatientfromDS(dob: any) {
    console.log("apna dob... " + dob)
    // Ensure VerifypatientModule is initialized
    if (!this.VerifypatientModule) {
      this.VerifypatientModule = {
        DOB: '',
        PRACTICE_CODE: '',
        LAST_NAME: '',
        FIRST_NAME: '',
        APPOINTMENT_ID: ''
      };
    }
    this.spinner.show();
    this.VerifypatientModule.DOB = dob;
    this.VerifypatientModule.PRACTICE_CODE = this.getPatientInfo.practiceCode.toString();
    
    this.VerifypatientModule.LAST_NAME = this.getPatientInfo.lastName;

    this.VerifypatientModule.FIRST_NAME = this.getPatientInfo.firstName;

    this.VerifypatientModule.APPOINTMENT_ID = this.getPatientInfo.appointment_id;
    console.log("VerifypatientModule..." + this.VerifypatientModule.DOB)
    this._VerifypatientService.VerifyPatient_v1(this.VerifypatientModule).subscribe((res: any) => {
      this.spinner.hide();
      if (res.RESPONSE[0]) {

        this.PatientPersonalInfo = res.RESPONSE[0] as PatientPersonalInfo;
        this.PatientPersonalInfo.PRACTICE_CODE = this.VerifypatientModule.PRACTICE_CODE;
        this.PatientPersonalInfo.isShowpicture = true;
        this.PatientPersonalInfo.PracticeName = this.getPatientInfo.practiceName;
        this.PatientPersonalInfo.PROVIDER_CODE = this.getPatientInfo.providerCode;
        let data = this._phrutilService.encrypt(this.PatientPersonalInfo);

        console.log("verii loc " + localStorage.getItem("AuthTokenwebServices"));
        localStorage.setItem('PersonalInfo', data);
        localStorage.setItem("AuthToken", res.RESPONSE[0].ACCESS_TOKEN);
        localStorage.setItem('patientAccount', this.PatientPersonalInfo.PATIENT_ACCOUNT)
        localStorage.setItem('userName', this.PatientPersonalInfo.EMAIL_ADDRESS)
        this.updateinfoservice.onIsShowProfilePic();
        this._VerifypatientService.startRefreshTokenTimer();

        if (this.isLockScreen) {
          localStorage.setItem("lockscreen", "true");
          this._router.navigateByUrl('/patient/consent-form');
        }
        else
          this._router.navigateByUrl('/patient/consent-form');
      } else {
        $("#incorrectinfo-model").modal("show");
      }
    }, (error: any) => {
      $("#incorrectinfo-model").modal("show");
      this.spinner.hide();
    })

  }
  ConverttoLocalDate(date: any): string {
    // if (!date) return '';

    if (date instanceof Date) {
      date = this.hasTimezone(date) ? this.removeZ(date) : date;

      // date = moment(date).format('MM/DD/Y h:mm:ss');
      date = moment(date).format('MM/DD/YYYY');
      // date = new Date(date);
    }

    return date;
  }
  onlyCharAllow(event: any, type: any) {
    if (event.value.trim()) {
      let validname = event.value.replace(/[^a-zA-Z ]/g, "");
      event.value = validname;
    }
    else {
      event.value = event.value.trim();
      this.loginForm.controls[type].setValue(event.value);
    }
  }
  checkinBeforeThreeHours(visitDate: any, visitTime: any) {
    try {
      // Combine visitDate and visitTime into a single string
      const visitDateTimeStr = `${visitDate} ${visitTime}`;

      // Parse visit date and time into a Date object without converting to local timezone
      const visitDateTime = this.ConverttoLocalDateForDiff(visitDateTimeStr);
      console.log("3 hour visit date time: " + visitDateTime);

      // Get the current date and time in UTC
      const currentDateTime = this.ConverttoLocalDateForDiff(new Date());
      console.log("3 hour current date time: " + currentDateTime);

      // Calculate the difference in milliseconds
      const diffInMs = visitDateTime.getTime() - currentDateTime.getTime();

      // Convert the difference to hours
      const diffInHours = diffInMs / (1000 * 60 * 60);
      console.log("3 hour difference: " + diffInHours);

      // Check if the difference is within 3 hours
      return diffInHours <= 3 && diffInHours >= 0;
    } catch (error) {
      console.error("An error occurred while calculating the time difference:", error);
      // Return false if an error occurs
      return false;
    }

  }
  checkIfVisitWithin24Hours(visitDate: string, visitTime: string): boolean {

    const visitDateTime = this.ConverttoLocalDate(visitDate);
    console.log("visit date time " + visitDateTime);
    console.log("visit date time " + typeof visitDateTime);


    // const currentDateFormatted = this.getCurrentDateFormatted();
    // console.log("current date with format " + currentDateFormatted)



    const currentDateTime = this.ConverttoLocalDate(new Date());
    console.log("current date time " + currentDateTime);
    console.log("current date time " + typeof currentDateTime);


    // Add one day to today's date
    const nextDay = this.ConverttoLocalDateInDay(new Date());
    nextDay.setDate(nextDay.getDate() + 1);



    const nextDaydate = this.ConverttoLocalDate(nextDay);
    console.log("next day date " + nextDaydate);
    //console.log("current date time " + typeof currentDateTime);

    if ((visitDateTime.trim() === currentDateTime.trim()) || (visitDateTime.trim() === nextDaydate.trim())) {
      return true;
    } else {
      return false;
    }

  }
  ConverttoLocalDateInDay(date: any): Date {
    // if (!date) return '';

    if (date instanceof Date) {
      date = this.hasTimezone(date) ? this.removeZ(date) : date;

      // date = moment(date).format('MM/DD/Y h:mm:ss');
      date = moment(date).format('MM/DD/YYYY');
      date = new Date(date);
    }

    return date;
  }
  ConverttoLocalDateForDiff(date: any): Date {
    // if (!date) return '';

    // if (date instanceof Date) {
    date = this.hasTimezone(date) ? this.removeZ(date) : date;

    date = moment(date).format('MM/DD/Y h:mm:ss');
    //date = moment(date).format('MM/DD/YYYY');
    date = new Date(date);

    // }

    return date;
  }
  private hasTimezone(value: any) {
    if (typeof value !== 'string') return false;
    return (value.includes('T') || value.includes('t'));
  }

  private removeZ(value: any) {
    if (!value) return '';
    return value.replace(/z|Z/, '');
  }

  getPaymentDetails() {
    this.spinner.show();
    this.service.getPaymentDetailsOld(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account).subscribe((res: any) => {
      this.spinner.hide();
   
      if (res && res.statusCode == 200 && res.message == 'SUCCESS' && res.data) {
        this.paymentDetials = res as PaymentDeiails;
        this.amountDueTemp = Number(this.paymentDetials.data.totalAmount);

        // Check if amT_DUE is 0
        if (Number(this.paymentDetials.data.amT_DUE) <= 0) {
          $("#No_due").modal("show");
          return;
        }
        else {
          this._router.navigateByUrl("/payment-overview");
        }
        if (Number(this.paymentDetials.data.totalAmount) < 0 && this.paymentDetials.data.totalAmount.includes('-')) {
          this.isMinuTotalAmount = this.paymentDetials.data.totalAmount.replace('-', '');
          this.isMinuTotalAmount = Number(this.isMinuTotalAmount).toLocaleString();
        }
        if (Number(this.paymentDetials.data.amT_DUE) < 0 && this.paymentDetials.data.amT_DUE.includes('-')) {
          this.isMinuDueAmount = this.paymentDetials.data.amT_DUE.replace('-', '');
          this.isMinuDueAmount = Number(this.isMinuDueAmount).toFixed(2).toLocaleString();
        }
        this.paymentDetials.data.amT_DUE = Number(this.paymentDetials.data.amT_DUE).toFixed(2).toLocaleString();
        this.paymentDetials.data.totalAmount = Number(this.paymentDetials.data.totalAmount).toFixed(2).toLocaleString();
        if (Number(this.paymentDetials.data.currentDayAmount) > 0) {
          this.isCopay = true;
        } else {
          this.isCopay = false;
        }
        if (Number(this.paymentDetials.data.amT_DUE) > 0) {
          this.isoutstanding = true;
        } else {
          this.isoutstanding = false;
        }
        if (this.isCopay == true && this.isoutstanding == false) {
          this.ShowAmountField = false;
        }
       
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
    });
  }

  }
